export default __webpack_public_path__ + "static/media/Supervity-Software-requirements-and-dependencies-installation-steps.48bb71a1.docx";